// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"HeadDevice_TheComp__WVcNz"};